import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { HeadingText, BodyText, DropdownMenu } from '@paypalcorp/pp-react';
import GivingSummaryAction from '../givingSummaryAction/givingSummaryAction';
import styles from './givingSummaryHeader.less';
import * as analytics from '../../lib/analytics';

const GivingSummaryHeader = ({
  isEngaged = true,
  heading,
  subheading,
  dropdownLabel,
  dateRanges = [],
  suggestedActions = [],
  selectedTimeFrame,
  onSelectionChange,
  defaultFPTITags,
  cdnHost,
  showPreviousYear,
  isLoading,
}) => {
  const selectionOptions = dateRanges.map((range) => ({
    primaryText: range.displayTitle,
    value: range.displayTitle,
  }));

  useEffect(() => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_IMPACT_SUMMARY_TIME_SELECTOR_SHOWN,
      {
        ...defaultFPTITags,
        e: 'im',
      }
    );
  }, []);

  const handleOnChange = (event) => {
    const { selectedIndex = 0 } = event.target;
    onSelectionChange(selectedIndex);
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_TIME_FRAME_OPTION_SELECTION_PRESSED,
      {
        ...defaultFPTITags,
        e: 'cl',
      }
    );
  };

  const trackDropDownClickEvent = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_IMPACT_SUMMARY_TIME_SELECTOR_PRESSED,
      {
        ...defaultFPTITags,
        e: 'cl',
      }
    );
  };

  const trackDropDownCloseEvent = () => {
    analytics.instance.recordEvent(
      analytics.events.DW_GIVING_TIME_FRAME_OPTION_DISMISS_PRESSED,
      {
        ...defaultFPTITags,
        e: 'cl',
      }
    );
  };

  const actionItems = suggestedActions.map((action, index) => (
    <GivingSummaryAction key={index} action={action} />
  ));

  const newUserIntro = (
    <div className={styles.content}>
      <img
        src={`https://${cdnHost}/paypal-ui/pictograms/multicolored/svg/trust.svg`}
        alt=''
        className={styles.pictogram}
      />
      <HeadingText className={styles.heading} size='sm'>
        {heading}
      </HeadingText>
      <BodyText className={styles.subheading}>{subheading}</BodyText>
      <div className={styles.actionsGroup}>{actionItems}</div>
    </div>
  );

  return (
    <>
      {isEngaged ? (
        <div className={styles.header}>
          <HeadingText className={styles.heading} size='sm'>
            {heading}
          </HeadingText>
          {!isLoading && showPreviousYear ? (
            <DropdownMenu
              className={styles.selector}
              label={dropdownLabel}
              options={selectionOptions}
              value={selectedTimeFrame.displayTitle}
              onChange={handleOnChange}
              onClose={trackDropDownCloseEvent}
              onClick={trackDropDownClickEvent}
            />
          ) : null}
        </div>
      ) : (
        newUserIntro
      )}
    </>
  );
};

GivingSummaryHeader.propTypes = {
  isEngaged: PropTypes.bool,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  dropdownLabel: PropTypes.string,
  dateRanges: PropTypes.array,
  suggestedActions: PropTypes.array,
  onSelectionChange: PropTypes.func,
  defaultFPTITags: PropTypes.object,
  cdnHost: PropTypes.string,
  showPreviousYear: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default GivingSummaryHeader;
